/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : userUpdateAction.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import customConsole from '../../config/customConsole';
import useAxios from '../../hooks/useAxios';

const baseURL = process.env.REACT_APP_BASE_URL;

export const UploadUserPicAction = ({ file }) => {
    let api = useAxios();

    return async (dispatch) => {
        return await api
            .post(`${baseURL}/UCM/files/upload`, file)
            .then(res => {
                if (res?.data?.error) {
                    return { error: true, msg: res?.data?.message || res?.data?.msg };
                }
                else {
                    return { error: false, msg: res?.data?.message || res?.data?.msg, user_profile_pic_name: res?.data?.file_name };
                }
            })
            .catch(err => {
                customConsole("-- Upload User Profile API --")
                customConsole(err);

                return { error: true, msg: err?.response?.data?.message || err?.response?.data?.msg };
            })
    }
}


export const GetUserPicAction = ({ filename }) => {
    let api = useAxios();

    return async (dispatch) => {
        return await api
            .get(`${baseURL}/UCM/files/details`, {
                params: { filename },
                responseType: "blob",
            })
            .then(res => {
                if (res.status === 200) {
                    const blob = res?.data;

                    const picPath = URL.createObjectURL(blob);

                    return { error: false, user_profile_pic_path: picPath };
                }
                else {
                    customConsole(res);

                    return { error: true, msg: "Failed to get the image" };
                }
            })
            .catch(err => {
                customConsole("-- Get Profile Pic API --")
                customConsole(err);

                return { error: true, msg: err?.response?.data?.message || err?.response?.data?.msg };
            })
    }
}